import { db } from '../../firebase';
import {
    collection,
    getDocs,
    query,
    where,
    orderBy
} from 'firebase/firestore';

/**
 * Get all roadmap entries
 */
export const getAllRoadmaps = async () => {
    try {
        const ref = collection(db, 'roadmaps');
        const snapshot = await getDocs(ref);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching roadmaps:', error);
        return [];
    }
};

/**
 * Get all hands-on entries
 */
export const getAllHandsOn = async () => {
    try {
        const ref = collection(db, 'handson');
        const snapshot = await getDocs(ref);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching hands-on:', error);
        return [];
    }
};

/**
 * Get all coaching entries
 */
export const getAllCoaching = async () => {
    try {
        const ref = collection(db, 'coaching');
        const snapshot = await getDocs(ref);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching coaching:', error);
        return [];
    }
};

/**
 * Get planning statistics (for dashboard)
 */
export const getPlanningStats = async () => {
    try {
        const [roadmaps, handson, coaching] = await Promise.all([
            getAllRoadmaps(),
            getAllHandsOn(),
            getAllCoaching()
        ]);

        return {
            roadmapCount: roadmaps.length,
            handsonCount: handson.length,
            coachingCount: coaching.length,
            roadmapRevenue: roadmaps.length * 1500, // Monthly fee assumption
            handsonRevenue: handson.length * 2500,
            coachingRevenue: coaching.length * 5000
        };
    } catch (error) {
        console.error('Error calculating planning stats:', error);
        return { roadmapCount: 0, handsonCount: 0, coachingCount: 0, roadmapRevenue: 0 };
    }
};
